


































































import Vue, { CreateElement } from "vue";
import router from "@/router";
import { createComponent, ref, watch } from "@vue/composition-api";

import { useActions } from "@/shared/useMegaraxClient";
import { SortOrder, DefaultSortOptions } from "element-ui/types/table";
import DebouncedInput from "@/components/form/DebouncedInput.vue";
import { Resource } from "@megarax/client/src";
import { ListActions } from "@megarax/client/src/actions";

interface Props {
  resource: Resource<ListActions<any>>;
  defaultSortBy: string[];
  extraFilters: { [key: string]: any };
}

export default createComponent<Props>({
  name: "ResourceItemTable",
  components: { DebouncedInput },
  props: {
    resource: {
      required: true,
    },
    defaultSortBy: {
      default: () => [],
    },
    extraFilters: { default: () => {} },
  },
  setup(props, ctx) {
    const tableRef = ref(null);

    const table = ref(null);

    const items = ref<any[] | null>(null);

    const filters = ref<{ [name: string]: any }>({});

    const search = ref("");
    const itemCount = ref(0);
    const searchText = ref("");
    const currentPage = ref(1);
    const perPage = 50;
    const isBusy = ref(false);

    const sortBy = ref<string | null>(null);

    function onSortChange({
      prop,
      order,
      column: { columnKey },
    }: {
      prop: string;
      order: SortOrder | null;
      column: { columnKey: string };
    }) {
      if (!order) sortBy.value = null;
      else if (order == "descending") sortBy.value = "-" + columnKey;
      else sortBy.value = columnKey;
    }

    function onFilterChange(newFilters: any) {
      filters.value = { ...filters.value, ...newFilters };
    }

    var lastRequestIndex = 0;

    const actions = useActions(props.resource);

    async function fetchItems() {
      const thisRequestIndex = ++lastRequestIndex;

      isBusy.value = true;
      const sortByArray = sortBy.value
        ? [sortBy.value, ...props.defaultSortBy]
        : props.defaultSortBy;

      const resp = await actions.fetchListPage(currentPage.value - 1, perPage, {
        ...filters.value,
        ...props.extraFilters,
        search: search.value,
        o: sortByArray,
      });

      // ignore the results if there is a newer request
      if (lastRequestIndex > thisRequestIndex) return;

      itemCount.value = resp.count;
      items.value = resp.items;
      isBusy.value = false;
    }

    function onRowClick(row: any) {
      ctx.emit("input", row);
    }

    fetchItems();

    watch([currentPage, sortBy, search, filters], fetchItems, { lazy: true });
    watch(() => props.extraFilters, fetchItems, { lazy: true, deep: true });

    return {
      tableRef,
      search,
      currentPage,
      filters,
      isBusy,
      items,
      itemCount,
      onRowClick,
      perPage,
      searchText,
      onSortChange,
      onFilterChange,
    };
  },
});
